import React from "react";
import { Button } from "antd";
import {
  WeaDialog,
  WeaTab,
  WeaFormItem,
  WeaSearchGroup,
  WeaPopoverHrm,
  WeaTable as WeaTableSelf,
  WeaLocaleProvider,
  WeaLeftRightLayout
} from "ecCom";
import WeaSwitch from "../../wea-switch";
import WeaTableNew from "../../wea-table-new";
import { observer } from "mobx-react";
import isEmpty from "lodash/isEmpty";
import forEach from "lodash/forEach";
import middleware from "../../../middleware";
import Store from "../stores/LogStore";

const WeaTable = WeaTableNew.WeaTable;
const getLabel = WeaLocaleProvider.getLabel;

@observer
class ColATag extends React.PureComponent {
  onClick = () => {
    this.props.onClick(this.props.record);
  };
  render() {
    return (
      <a className="common" href="javascript:void(0);" onClick={this.onClick}>
        {getLabel("33564", "查看")}
      </a>
    );
  }
}

@observer
class LogComponent extends React.PureComponent {
  static Store = Store;

  constructor(props) {
    super(props);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.visible && nextProps.visible != this.props.visible) {
      this.init(nextProps);
    }
  }

  componentDidMount() {
    if (this.props.visible) {
      this.init(this.props);
    }
  }

  init(nextProps) {
    const {
      logStore,
      logType,
      logSmallType,
      targetId,
      params = {}
    } = nextProps;
    logStore.update({
      logType,
      logSmallType,
      targetId,
      advanceShow: false,
      detailVisible: false
    });
    logStore.initForm();
    logStore.getDatas(params);
  }

  formatContent(record) {
    let temp = "";
    let newValues = {};
    let oldValues = {};
    if (record.newValue) {
      try {
        newValues = JSON.parse(record.newValue);
      } catch (error) {
        newValues = record.newValue;
      }
    }
    if (record.oldValue) {
      try {
        oldValues = JSON.parse(record.oldValue);
      } catch (error) {
        oldValues = record.oldValue;
      }
    }
    if (!isEmpty(newValues) || !isEmpty(oldValues)) {
      let target = isEmpty(newValues) ? oldValues : newValues;
      temp += `<ol style='list-style: decimal; margin-left: 20px'>`;
      forEach(target, (value, key) => {
        temp += `<li style='margin-bomtto: 4px'>[${key}]:&nbsp;`;
        if (oldValues[key] !== undefined && newValues[key] !== undefined) {
          temp =
            temp +
            getLabel("385867", '由&nbsp;"$s"修改为&nbsp;').replace(
              /\$s/,
              oldValues[key]
            ) +
            `"<span style='color: #FF0000'>${newValues[key]}</span>"</li>`;
        } else {
          temp += `${value}</li>`;
        }
      });
      temp += "</ol>";
    }
    return temp;
  }

  formatParams(record) {
    let text = "";
    if (!isEmpty(record.params)) {
      text = `<pre><code>${JSON.stringify(
        JSON.parse(record.params),
        null,
        2
      )}</code></pre>`;
    }
    return text;
  }

  aTagClick = e => window.pointerXY(e);

  colATagClick = record => {
    const { logStore } = this.props;
    if (
      record.clientIp ||
      window.location.href.includes("www.e-cology.com.cn/wui/etodo.html")
    ) {
      let title = `${record.operateTypespan} -
      ${record.logsmalltypelabelnamespan || ""}
      : ${record.targetNamespan}`;
      logStore.setDetailTitle(title);
      logStore.updateDetailkey(`${new Date().getTime()}`);
      logStore.setShowParams(false);
      logStore.setDetailRecord(record);
      logStore.getDetailTable();
      logStore.zhangChenGetDatas(record.keyidspan || record.id);
    }
  };

  onEnterSearch = () => {
    const { logStore, params = {} } = this.props;
    logStore.getDatas(params);
    logStore.update({
      advanceShow: false
    });
  };

  doClear = () => this.props.logStore.setShowParams(false);

  doSubmit = () => this.props.logStore.setShowParams(true);

  doSearch = () => {
    const { logStore, params = {} } = this.props;
    logStore.getDatas(params);
    this.hideSearchAd();
  };

  doReset = () => this.props.logStore.form.resetConditionValue();

  doCancel = () => this.props.logStore.setDetailVisible(false);

  setShowSearchAd = bool => this.props.logStore.updateAdvanceShow(bool);

  hideSearchAd = () => this.props.logStore.updateAdvanceShow(false);

  getButtons() {
    const {
      logStore: { showParams }
    } = this.props;
    const buttons = [];
    if (showParams) {
      buttons.push(
        <Button key="clear" type="ghost" onClick={this.doClear}>
          {getLabel("385865", "返 回")}
        </Button>
      );
    } else {
      buttons.push(
        <Button key="submit" type="primary" onClick={this.doSubmit}>
          {getLabel("385866", "查看原始参数")}
        </Button>
      );
    }
    return buttons;
  }

  //定义tab中点击高级搜索时的最下面的操作按钮集合
  getTabButtonsAd() {
    return [
      <Button type="primary" onClick={this.doSearch}>
        {getLabel("197", "搜索")}
      </Button>,
      <Button type="ghost" onClick={this.doReset}>
        {getLabel("2022", "重置")}
      </Button>,
      <Button type="ghost" onClick={this.hideSearchAd}>
        {getLabel("31129", "取消")}
      </Button>
    ];
  }

  getSearchs = () => {
    const { logStore } = this.props;
    const { form, conditions, targetId } = logStore;
    const { isFormInit } = form;
    let group = [];
    if (isFormInit) {
      const formParams = form.getFormParams(); // 获取表单的值
      isFormInit &&
        conditions.map(c => {
          let items = [];
          c.items.map(fields => {
            items.push({
              com: (
                <WeaFormItem
                  label={`${fields.label}`}
                  labelCol={{ span: `${fields.labelcol}` }}
                  wrapperCol={{ span: `${fields.fieldcol}` }}
                >
                  {/*根据 WeaSwitch 获取对应的组件*/}
                  <WeaSwitch
                    fieldConfig={fields}
                    form={form}
                    formParams={formParams}
                    onEnterSearch={this.onEnterSearch}
                  />
                </WeaFormItem>
              ),
              colSpan: 1,
              hide: form.isHide(fields, keys => {
                if (
                  keys.indexOf("targetId") >= 0 &&
                  targetId &&
                  targetId !== ""
                )
                  return true;
                return false;
              })
            });
          });
          group.push(
            <WeaSearchGroup
              needTigger={false}
              showGroup={c.defaultshow}
              items={items}
            />
          );
        });
    }
    return group;
  };

  getColumns = columns => {
    columns = columns.map(col => {
      if (col.dataIndex == "userid") {
        let newCol = { ...col };
        newCol.render = (value, record, index) => {
          return (
            <a
              href={`javaScript:openhrm(${record.userid});`}
              onClick={this.aTagClick}
              title={record.useridspan}
              dangerouslySetInnerHTML={{ __html: record.useridspan }}
            ></a>
          );
        };
        return newCol;
      } else if (col.dataIndex == "id" || col.dataIndex == "newValues") {
        let newCol = { ...col };
        newCol.render = (value, record, index) => {
          return <ColATag record={record} onClick={this.colATagClick} />;
        };
        return newCol;
      }
      return col;
    });
    return columns;
  };

  renderRight = () => {
    const { dialogProps = {}, logStore, icon, iconBgcolor } = this.props;
    let {
      advanceShow,
      tableStore,
      detailRecord,
      zhangChenFields,
      detailKey,
      detailTitle,
      detailVisible,
      showParams,
      viewdetailDatas,
      viewdetailTitles,
      viewdetailColums
    } = logStore;
    const buttons = this.getButtons();
    const temp = this.formatContent(detailRecord);
    const text = this.formatParams(detailRecord);
    const zhangChenFieldsTemp = this.formatContent(zhangChenFields);
    const zhangChenFieldsText = this.formatParams(zhangChenFields);
    return (
      <WeaPopoverHrm inDialog={true}>
        <WeaDialog
          hasScroll
          key={detailKey}
          onCancel={this.doCancel}
          title={`${detailTitle}`}
          icon={icon || "icon-coms-Flow-setting"}
          iconBgcolor={iconBgcolor || "#407008"}
          visible={detailVisible}
          style={{ width: 1000, height: 700 }}
          buttons={buttons}
          className="wea-log-view-detail"
          {...dialogProps}
        >
          {((!showParams && temp !== "") || (showParams && text !== "")) && (
            <React.Fragment>
              <div
                style={{ padding: 20, overflowX: "scroll" }}
                dangerouslySetInnerHTML={{
                  __html: !showParams ? temp : text
                }}
              />
              <br />
              <br />
            </React.Fragment>
          )}
          {(zhangChenFieldsTemp !== "" || zhangChenFieldsText !== "") && (
            <React.Fragment>
              <div
                style={{ padding: 20, overflowX: "scroll" }}
                dangerouslySetInnerHTML={{
                  __html: !showParams
                    ? zhangChenFieldsTemp
                    : zhangChenFieldsText
                }}
              />
              <br />
            </React.Fragment>
          )}
          {!isEmpty(viewdetailDatas) &&
            viewdetailDatas.map((datas, index) => {
              return (
                <div style={{ paddingTop: "15px" }}>
                  <div
                    style={{
                      padding: "0 0 8px 12px",
                      borderBottom: "1px solid #e2e2e2"
                    }}
                  >
                    {viewdetailTitles[index] == "@#"
                      ? ""
                      : viewdetailTitles[index] + ":"}
                  </div>
                  {viewdetailColums.length > 0 &&
                    !isEmpty(viewdetailColums[index]) && (
                      <WeaTableSelf
                        columns={viewdetailColums[index]}
                        dataSource={datas}
                        pagination={false}
                        scroll={{ x: 993, y: 700 }}
                      />
                    )}
                </div>
              );
            })}
        </WeaDialog>
        <WeaTab
          searchType={["advanced"]}
          advanceHeight={160}
          showSearchAd={advanceShow}
          setShowSearchAd={this.setShowSearchAd}
          hideSearchAd={this.hideSearchAd}
          searchsAd={this.getSearchs()}
          buttonsAd={this.getTabButtonsAd()}
          buttons={this.renderTabButtons()}
        />
        <div className="logview-table">
          <WeaTable
            comsWeaTableStore={tableStore}
            getColumns={this.getColumns}
            needScroll={true}
            outerHeight={480}
          />
        </div>
      </WeaPopoverHrm>
    );
  };
  renderTabButtons() {
    const { showCurrentExportBtn, showAllExportBtn, logStore } = this.props;
    const buttons = [];
    if (showCurrentExportBtn) {
      const str = getLabel("17416", "导出") + getLabel("528614", "当前页");
      buttons.push(
        <Button type="primary" onClick={logStore.exportCurrent}>
          {str}
        </Button>
      );
    }
    if (showAllExportBtn) {
      const str = getLabel("17416", "导出") + getLabel("332", "全部");
      buttons.push(
        <Button type="primary" onClick={logStore.exportAll}>
          {str}
        </Button>
      );
    }
    if (buttons.length > 1) {
      buttons[buttons.length - 1].props.style = { marginRight: 15 };
    }

    return buttons;
  }

  render() {
    const { leftCom, title } = this.props;
    const rightCom = this.renderRight();
    return (
      <WeaDialog
        title={title || getLabel("31709", "日志查看")}
        style={{ height: 550, width: 1075 }}
        {...this.props}
        icon="icon-coms-currency"
        iconBgcolor="#217346"
      >
        {leftCom ? (
          <div style={{ height: "100%" }}>
            <WeaLeftRightLayout leftCom={leftCom}>
              <div>{rightCom}</div>
            </WeaLeftRightLayout>
          </div>
        ) : (
          rightCom
        )}
      </WeaDialog>
    );
  }
}

const Com = middleware(LogComponent, "WeaLogView");
export default Com;



// WEBPACK FOOTER //
// ./comMobx/wea-log-view/components/LogComponent.js